// types
import { DefaultConfigProps } from 'types/config';

/** Opens an invoice with its comments drawer on the comment the value names. */
export const commentParam = 'comment';

export const AWS_API = {
    poolId: import.meta.env.VITE_COGNITO_POOL_ID,
    appClientId: import.meta.env.VITE_COGNITO_APP_CLIENT_ID,
};

// ==============================|| APP CONFIG  ||============================== //

const config: DefaultConfigProps = {
    defaultPath: '/home',
    miniDrawer: false,
    container: false,
};

export default config;
